function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }
var id = 0;
function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }
var _isFocusable = /*#__PURE__*/_classPrivateFieldLooseKey("isFocusable");
var _attemptFocus = /*#__PURE__*/_classPrivateFieldLooseKey("attemptFocus");
var _focusLastDescendant = /*#__PURE__*/_classPrivateFieldLooseKey("focusLastDescendant");
/**
 * Usada para garantir que a navagção por Tab vai se manter
 * nos elementos que pertençam ao Modal ou Alert sendo exibido
 */
var AriaTabTrap = function AriaTabTrap(getCurrentContainer) {
  var _this = this;
  /**
   * Envolve o container com 2 nodes invisíveis e passíveis de foco,
   * para que enquanto estiver sendo exibida eles sejam usados para
   * garantir que o foco nunca saia dos elementos do container
   * @param {*} containerRef
   */
  this.bracketContainerWithFocusableNodes = function (containerRef) {
    var preDiv = document.createElement('div');
    _this.preNode = containerRef.parentNode.insertBefore(preDiv, containerRef);
    _this.preNode.tabIndex = 0;
    var postDiv = document.createElement('div');
    _this.postNode = containerRef.parentNode.insertBefore(postDiv, containerRef.nextSibling);
    _this.postNode.tabIndex = 0;
  };
  Object.defineProperty(this, _isFocusable, {
    writable: true,
    value: function value(element) {
      if (element.tabIndex < 0) {
        return false;
      }
      if (element.disabled) {
        return false;
      }
      switch (element.nodeName) {
        case 'A':
          return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
          return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
          return true;
        default:
          return false;
      }
    }
  });
  Object.defineProperty(this, _attemptFocus, {
    writable: true,
    value: function value(element) {
      if (!_classPrivateFieldLooseBase(_this, _isFocusable)[_isFocusable](element)) {
        return false;
      }
      AriaTabTrap.ignoreUtilFocusChanges = true;
      try {
        element.focus();
      } catch (e) {
        // continue regardless of error
      }
      AriaTabTrap.ignoreUtilFocusChanges = false;
      return document.activeElement === element;
    }
  });
  this.focusFirstDescendant = function (element) {
    for (var i = 0; i < element.childNodes.length; i += 1) {
      var child = element.childNodes[i];
      if (_classPrivateFieldLooseBase(_this, _attemptFocus)[_attemptFocus](child) || _this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  };
  Object.defineProperty(this, _focusLastDescendant, {
    writable: true,
    value: function value(element) {
      for (var i = element.childNodes.length - 1; i >= 0; i -= 1) {
        var child = element.childNodes[i];
        if (_classPrivateFieldLooseBase(_this, _attemptFocus)[_attemptFocus](child) || _classPrivateFieldLooseBase(_this, _focusLastDescendant)[_focusLastDescendant](child)) {
          return true;
        }
      }
      return false;
    }
  });
  this.trapFocus = function (event) {
    if (AriaTabTrap.ignoreUtilFocusChanges) {
      return;
    }
    var currentContainerData = _this.getCurrentContainer();
    var currentContainer = currentContainerData == null ? void 0 : currentContainerData.containerRef;
    if (!currentContainer) {
      return;
    }
    if (currentContainer.contains(event.target)) {
      currentContainer.lastFocus = event.target;
    } else {
      _this.focusFirstDescendant(currentContainer);
      if (currentContainer.lastFocus === document.activeElement) {
        _classPrivateFieldLooseBase(_this, _focusLastDescendant)[_focusLastDescendant](currentContainer);
      }
      currentContainer.lastFocus = document.activeElement;
    }
  };
  AriaTabTrap.ignoreUtilFocusChanges = false;
  this.getCurrentContainer = getCurrentContainer;
};
AriaTabTrap.ignoreUtilFocusChanges = void 0;
export default AriaTabTrap;